module.exports = "data:image/jpeg;base64,"